import {Alert, Grid} from '@mui/material'
import {getLocalDate} from '../../../utils/utilities'
import {projectedCycle} from '../checkInWizardRules'

// The summary the admin sees before publishing: when the check-in starts, how
// many surveys one cycle takes and when the first cycle is expected to end.
// The end date was missing altogether; the start alone does not say how long
// pupils will be asked for.
export default function CheckInCycleProjection({startDate, frequency, surveys}) {
  const projection = projectedCycle({startDate, frequency, surveys})
  if (!projection) return null

  const {instanceCount, endDate} = projection
  return (
    <Grid container>
      <Grid item xs={12} mt={3}>
        <Alert severity="info">
          Starts on <strong>{getLocalDate(projection.startDate)}</strong>. One
          cycle is {instanceCount} check-in {instanceCount === 1 ? 'survey' : 'surveys'};
          the first cycle is expected to end on{' '}
          <strong>{getLocalDate(endDate)}</strong>.
        </Alert>
      </Grid>
    </Grid>
  )
}
